import { ErrorBoundary } from "@sentry/react";
import ErrorFallback from "features/errorCatching/components/ErrorFallback";
import { Route, RouteProps } from "react-router-dom";

const RouteWithErrorBoundary: React.FC<RouteProps> = (props) => {
    return (
        <ErrorBoundary
            fallback={ErrorFallback}
            beforeCapture={(scope) => {
                scope.setTag("location", props.path?.toString() || "-");
            }}
        >
            <Route {...props} />
        </ErrorBoundary>
    );
};

export default RouteWithErrorBoundary;
